export default __webpack_public_path__ + "static/media/Welcome-Svg.4a36f510.svg";